
import { useBankerVM } from "presentation/hook/Banker/useBankerVM";
import { useBankerTracked } from "presentation/store/Banker/BankerProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import BankerEditPanel from "./BankerEditPanel";
import BankerTablePanel from "./BankerTablePanel";

export const BankerMaintenance: React.FC = () => {
    const [bankerState] = useBankerTracked();
    const bankerVM = useBankerVM();
    const { isShowEditPanel } = bankerState;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    bankerVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {
                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            bankerVM.onSearch().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [bankerVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            {isShowEditPanel && <BankerEditPanel />}
            {!isShowEditPanel && <SliderPanel
                isOpen={true}
                leftSectionWidth={'100%'}
                rightSectionWidth={"0%"}
                draggable={false}
                leftChildren={<BankerTablePanel />}
            />}
        </div>
    </>
}